module.exports = __webpack_public_path__ + "img/process-3.b9191e19.png";